// extracted by mini-css-extract-plugin
export var label = "_a4-1";
export var reminder = "_a4-0";